import type { DetailBack } from '../hooks/useDetailBack';

// Shown when a conversation link 404s — its author purged their data, so the conversation row is
// gone (a dangling briefing reference). It takes the SAME back contract as the live note page, so
// the dead-link state cannot disagree with the page it stands in for: it used to be hardcoded to
// "Back to conversations" while navigating to the map's force-GRAPH, and to "Back to settings" on
// the sibling route — one screen, two answers, neither of them history-aware.
export function ConversationDeletedNotice({ back }: { back: DetailBack }) {
  return (
    <div
      className="v2-content"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, gap: 12 }}
    >
      <span style={{ color: 'var(--text2)', fontSize: 14, fontFamily: 'var(--mono)', letterSpacing: '0.08em' }}>
        This conversation was deleted
      </span>
      <span style={{ color: 'var(--text3)', fontSize: 12, maxWidth: 360, textAlign: 'center' }}>
        It was removed when its author deleted their data, so it&rsquo;s no longer available.
      </span>
      <button className="v2-btn" onClick={back.go}>{back.label}</button>
    </div>
  );
}
